import { combineReducers } from "redux";
import alert from "./alert";
import auth from "./auth";
import profile from "./profile";
import post from "./post";
import meeting from "./meeting";
import quotation from "./quotation";

export default combineReducers({
  alert,
  auth,
  profile,
  post,
  meeting,
  quotation,
});
